export type FirstAccessResult =
  | { ok: true; data?: Record<string, unknown> }
  | { ok: false; message?: string };

export type FirstAccessFailure = Extract<FirstAccessResult, { ok: false }>;

export const isFirstAccessFailure = (
  result: FirstAccessResult
): result is FirstAccessFailure => result.ok === false;

export const getFirstAccessErrorMessage = (
  result: FirstAccessFailure,
  fallback: string
): string => result.message ?? fallback;

export interface FirstAccessContextValue {
  username: string;
  /** Confirmed CPF digits (11) after confirm-cpf step. */
  confirmedCpf: string;
  livenessSessionId: string;
  /** True when OTP was already sent (e.g. password-reset/request). */
  otpAlreadySent: boolean;
  /** Entered via Esqueceu? / password-reset funnel. */
  fromPasswordReset: boolean;
  identifyUser: (username: string) => Promise<FirstAccessResult>;
  confirmCpf: (username: string, cpf: string) => Promise<FirstAccessResult>;
  startLiveness: (username: string) => Promise<FirstAccessResult>;
  completeLiveness: (
    username: string,
    sessionId: string
  ) => Promise<FirstAccessResult>;
  getLivenessStatus: (
    username: string,
    sessionId: string
  ) => Promise<FirstAccessResult>;
  sendVerificationCode: (username: string) => Promise<FirstAccessResult>;
  validateVerificationCode: (
    username: string,
    code: string
  ) => Promise<FirstAccessResult>;
  changePassword: (
    username: string,
    password: string,
    passwordTransaction: string
  ) => Promise<FirstAccessResult>;
  /** Clears one-shot skip of auto-send on validate-code mount. */
  consumeOtpAlreadySent: () => void;
}
